import React, {Component} from 'react'
import {Select} from 'antd'
import {compose} from 'recompose'

import withSelectFetch from '../withSelectFetch'
import withSpinning from '../../HOC/withSpinning'
import withSort from '../../HOC/withSort'
import withSubDropdown from '../../HOC/withSubDropdown'

const Option = Select.Option

class OvertimeSelect extends Component {
  render() {
    const {value, onChange, placeholder, data} = this.props
    return (
      <Select
        style={{minWidth: '130px'}}
        value={value}
        showSearch
        onChange={onChange}
        placeholder={placeholder || 'Select a Overtime'}
        filterOption={(input, option) =>
          option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
        }
        {...this.props}>
        {data.map(c => <Option value={c}>{c}</Option>)}
      </Select>
    )
  }
}

export default compose(
  withSelectFetch({dropdown: 'employee', name: 'contract'}),
  withSpinning,
  withSubDropdown({name: 'overtime'}),
  withSort,
)(OvertimeSelect)
